import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export const MAIN_CONTENT_ID = 'main-content';

/** First focusable element on the page. Keyboard users should not tab through the whole menu. */
export function SkipLink(): ReactNode {
  const { t } = useTranslation();
  return (
    <a
      href={`#${MAIN_CONTENT_ID}`}
      className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:rounded-sm focus:border focus:border-subtle focus:bg-surface-raised focus:px-3 focus:py-1.5 focus:text-xs focus:text-default"
    >
      {t('nav.skipToContent')}
    </a>
  );
}
